module.exports = __webpack_public_path__ + "static/2-6170be03b23c9cfddccd112832116db8.jpg";